import { Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-help',
  standalone: true,
  imports: [RouterOutlet, MatListModule, RouterLink, RouterLinkActive],
  templateUrl: './help.component.html',
  styleUrl: './help.component.scss',
})
export class HelpComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    this.authService.whenNotAuthenticated(() => {
      this.router.navigate(['/']);
    });
  }
}
